import React from 'react';
import Spinner from 'react-spinkit';
import View from '../ui/view';

export default function Description({ description, loading }) {
  const displayDescription = (description || '').replace(/[\r\n]/g, '<br />');

  return loading ? (
    <div className="col-xs-12 col-sm-9">
      <View padding="md" className="text-center">
        <Spinner spinnerName="three-bounce" />
      </View>
    </div>
  ) : (
    <p dangerouslySetInnerHTML={{ __html: displayDescription }} />
  );
}



// WEBPACK FOOTER //
// ./shared/components/product/description.js